export default "__VITE_ASSET__BBECj9id__"